import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Card,
  CardContent,
  Checkbox,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ListSubheader from "@mui/material/ListSubheader";
import Radio from "@mui/material/Radio";
import { useForm, Controller } from "react-hook-form";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import {
  CREATE_GROUP_USER_MUTATION,
  DELETE_GROUP_USER_MUTATION,
} from "../../graphQL/group_user";

var findAnd = require("find-and");

const useStyles = makeStyles(theme => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 30,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
  selectStyle: {
    minWidth: 350,
    height: 35,
    //  paddingLeft: 16,
    marginBottom: 10,
    "& .MuiOutlinedInput-input": {
      textAlign: "left",
    },
  },
  dataGridStyle: {
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#99D4FF",
      color: "#0D47A1",
    },

    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 14,
    },
  },
  card: {
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    padding: "20px",
    minHeight: "300px",
    borderRadius: "8px",
  },
}));

export default function UpdateGroupsDialog({
  staffFullName,
  clientName,
  username,
  staffGroupsCount,
  clntAllGrpAndIfIsStfGrp2Lst,
  reloadPageFunc,
  closeDialog,
}) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  
  const [groupsCount, setGroupsCount] = useState(staffGroupsCount);

  const [clntAllGrpAndIfIsStfGrp2LstData, setClntAllGrpAndIfIsStfGrp2LstData] = useState(
    clntAllGrpAndIfIsStfGrp2Lst
  );

  const [createGroupUser] = useMutation(CREATE_GROUP_USER_MUTATION);
  const [deleteGroupUser] = useMutation(DELETE_GROUP_USER_MUTATION);


  
  const handleChgCheckbox = (checked, item) => {
    setClntAllGrpAndIfIsStfGrp2LstData(
      findAnd.changeProps(
        clntAllGrpAndIfIsStfGrp2LstData,
        { groupId: item.groupId },
        { isStfGrp: checked }
      )      
    );
    if(checked == true)
        setGroupsCount(groupsCount + 1);
    else
      setGroupsCount(groupsCount - 1);
    
  };


  const handleSave = async () => {
    let reloadStaffPage = false;
    for (const key in clntAllGrpAndIfIsStfGrp2Lst) {
      if (
        clntAllGrpAndIfIsStfGrp2LstData[key] &&
        clntAllGrpAndIfIsStfGrp2Lst[key].groupId ===
          clntAllGrpAndIfIsStfGrp2LstData[key].groupId &&
        clntAllGrpAndIfIsStfGrp2Lst[key].isStfGrp !==
          clntAllGrpAndIfIsStfGrp2LstData[key].isStfGrp
      ) {
        reloadStaffPage = true;
        if (clntAllGrpAndIfIsStfGrp2LstData[key].isStfGrp) {
          const { data, error } = await createGroupUser({
            variables: {
              groupId: parseInt(clntAllGrpAndIfIsStfGrp2LstData[key].groupId),
              username,
            },
          });
          if (error) {
            console.log("Error", error, data);
          }
        } else {
          const { data, error } = await deleteGroupUser({
            variables: {
              groupId: parseInt(clntAllGrpAndIfIsStfGrp2LstData[key].groupId),
              username,
            },
          });
          if (error) {
            console.log("Error", error, data);
          }
        }
      }
    }
    handleClose();
    reloadPageFunc(reloadStaffPage);
  };
  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            maxWidth: "none",
          },
        }}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "600px",
              // height: "60%",
              // minWidth: "800px",
              // maxHeight: "600px",
            },
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="alert-dialog-title">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box mt={1} ml={1} sx={{ textAlign: "center", flexGrow: 1 }}>
              Manage Groups for Staff
            </Box>
            {closeDialog ? (
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  color: theme => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="h3"
            style={{
              fontSize: 16,
              textAlign: "left",
              marginBottom: 15,
              // paddingLeft: 10,
            }}
          >
            <b>Staff: </b> {staffFullName}
          </Typography>
          <Typography
            variant="h3"
            style={{
              fontSize: 16,
              textAlign: "left",
              marginBottom: 15,
              // marginLeft: 10,
            }}
          >
            <b>Client:</b> {clientName}
          </Typography>

          <Typography
            variant="h3"
            style={{
              fontSize: 16,
              textAlign: "left",
              marginBottom: 15,
              // marginLeft: 10,
            }}
          >
            <b>Staff should assign to one group at least.</b>
          </Typography>
          
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >          
            <Card
              variant="outlined"
              sx={{
                width: "80%",
                maxWidth: 500,
                borderRadius: 2,
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              }}
            >
              <CardContent
                sx={{
                  overflowY:
                    clntAllGrpAndIfIsStfGrp2LstData.length > 5 ? "auto" : "visible",
                  maxHeight: clntAllGrpAndIfIsStfGrp2LstData.length > 5 ? 250 : "none",
                }}
              >
                {clntAllGrpAndIfIsStfGrp2LstData ? (
                  clntAllGrpAndIfIsStfGrp2LstData.map((item, index) => (
                    <Grid
                      container
                      key={item.id || index}
                      alignItems="center"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        // alignItems: "center",
                        // paddingLeft: 15,
                      }}
                    >
                      <Grid item xs={1}>
                        {item.isStfGrp ?
                          (
                           <> 
                            {groupsCount === 1 ? 
                              (
                                <Checkbox
                                  checked={item.isStfGrp}
                                  disabled = "disabled"
                                  
                                />
                              )
                            :
                            (

                              <Checkbox
                              checked={item.isStfGrp}
                              onChange={e => handleChgCheckbox(e.target.checked, item)}
                            />

                             )
                           }
                          </> 
                          )
                          :
                          (
                            <Checkbox
                              checked={item.isStfGrp}
                              onChange={e => handleChgCheckbox(e.target.checked, item)}
                            />

                          )
                        }
                      </Grid>
                      <Grid item>
                        <Typography
                          variant="h3"
                          style={{
                            fontSize: 16,
                            textAlign: "left",
                          }}
                        >
                          {item.name}
                        </Typography>
                      </Grid>
                    </Grid>
                  ))
                ) : (
                  <Typography
                    variant="h3"
                    style={{
                      fontSize: 16,
                      textAlign: "center",
                      marginBottom: 15,
                      // paddingLeft: 0,
                    }}
                  >
                    This client has no group
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Box>
        </DialogContent>
        {clntAllGrpAndIfIsStfGrp2LstData ? (
          <DialogActions style={{ justifyContent: "center" }}>
            <Box mb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 2 }}
                onClick={handleSave}
              >
                Save
              </Button>
              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={handleClose}
              >
                Cancel
              </Button>
            </Box>
          </DialogActions>
        ) : (
          ""
        )}
      </Dialog>
    </div>
  );
}
